<template>
    <div id="course-list">
      <van-nav-bar
        :placeholder="true"
        :safe-area-inset-top="true"
        :fixed="true"
        :title="title"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      >
      <template #right>
        <van-icon  @click="search" name="search" size="24" />
      </template>
      </van-nav-bar>
      <empty v-if="courseInfo.length === 0"></empty>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        error-text="请求失败，点击重新加载"
        @load="getInitData"
      >
        <course-item v-bind:courseInfo="courseInfo"></course-item>
      </van-list>
      <bottom-nav></bottom-nav>
    </div>
</template>

<script>
import CourseItem from './components/CourseItem';
import BottomNav from './components/BottomNav';
import { Empty } from '@/components';
export default {
  components: { CourseItem, BottomNav, Empty },
  name: 'PreschoolCourseList',
  data () {
    return {
      courseType: ['课程列表', '幼师网校', '名师精品', '绘本听书', '家园共育'],
      courseLabelId: 0,
      title: '',
      courseInfo: [],
      loading: false,
      finished: false,
      pageNo: 1
    };
  },
  mounted () {
    // 获取传过来的参数
    let type = this.$route.params.type;
    this.title = type == null ? this.courseType[0] : this.courseType[type];
    let courseLabelIdList = [0, 8, 10, 9, 7];
    this.courseLabelId = type == null ? courseLabelIdList[0] : courseLabelIdList[type];
  },
  methods: {
    search () {
      this.$router.push({ name: 'PreschoolSearch' });
    },
    onClickLeft () {
      history.back();
    },
    getInitData () {
      // 获取初始化数据
      const { $http } = this;
      let params = null;
      if (this.courseLabelId === 0) {
        params = {
          pageNo: this.pageNo,
          channelId: 15
        };
      } else {
        params = {
          pageNo: this.pageNo,
          courseLabelId: this.courseLabelId
        };
      }
      $http.get('course/list', { params }).then((res) => {
        console.log('打印返回值', res);
        this.loading = false;
        this.finished = !res.data.page.isHasNext;
        this.pageNo = res.data.page.nextPage;
        this.courseInfo.push(...res.data.page.result);
      });
    }
  }
};
</script>

<style scoped>

</style>